import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  chooseLogInMethod: {
    defaultMessage: 'Choose your preferred login method',
    id: 'ChooseAuthMethodOverlay.chooseLogInMethod',
  },
  signInMethod: {
    defaultMessage: 'Sign in method',
    id: 'ChooseAuthMethodOverlay.signInMethod',
  },
  chooseConnectionMethod: {
    defaultMessage: 'What method would you like to connect with?',
    id: 'ChooseAuthMethodOverlay.chooseConnectionMethod',
  },
  withMethod: {
    defaultMessage: 'With {method}',
    id: 'ChooseAuthMethodOverlay.withMethod',
  },
  credentialsTypePassword: {
    defaultMessage: 'Password',
    id: 'ChooseAuthMethodOverlay.credentialsTypePassword',
  },
  credentialsTypeMobileBankId: {
    defaultMessage: 'Mobile BankID',
    id: 'ChooseAuthMethodOverlay.credentialsTypeMobileBankId',
  },
  credentialsTypeKeyfob: {
    defaultMessage: 'Code generator',
    id: 'ChooseAuthMethodOverlay.credentialsTypeKeyfob',
  },
  credentialsTypeThirdpartyApp: {
    defaultMessage: 'Mobile App',
    id: 'ChooseAuthMethodOverlay.credentialsTypeThirdpartyApp',
  },
});
